import {DynamicEntity} from "./dynamic_entity";

export class Player extends DynamicEntity {

    local = false;
    device_type = 0;

    constructor(uid, deviceType, isLocal) {
        super(uid, "player");

        this.device_type = deviceType;
        this.local = isLocal;
        this.offset = {x: 0, y: 48, z: 100}

        this.setSpeed(1.2); //Slightly faster than the default speed
        this.registerAction("walk_to", this.walk)
    }

    walk(data) {
        console.log("entity walk: ", data)

        this.setPosition(data.position.x, data.position.y, data.position.z) //TODO: Set position
    }

    update() {
        super.update()

        //Tween between position & target
    }

    onChat(message) {
        console.log("Player onChat: ", message)
    }
}